/* VER-AGENTIC-1, 25.08.2026 (Wolfram, verwuester.net)
   Lighthouse Agentic-Browsing-Audit, Accessibility-for-agents-FAIL:
   Flickity (assets/vendor-scripts-v9.js, Cell.prototype.select/unselect)
   setzt aria-hidden="true" auf nicht ausgewaehlten .slideshow__slide-
   Elementen und entfernt es bei Auswahl wieder. Fokussierbare Nachfahren
   (z.B. a.btn/.btn--inverse in .hero__link, oder weitere Links/Buttons in
   anderen Flickity-Slidern des Themes) bleiben davon unberuehrt und sind
   trotz aria-hidden per Tab erreichbar.
   Dieses Skript spiegelt aria-hidden jeder .slideshow__slide auf
   tabindex="-1" ihrer fokussierbaren Nachfahren, ueber einen
   MutationObserver auf das aria-hidden-Attribut. Das entkoppelt den Fix
   bewusst von theme.Slideshow/Flickity-internen Events (kein Edit an der
   216-KB-Datei assets/theme.js noetig) und faengt jede Slide ab, auch
   nachtraeglich eingefuegte (z.B. nach Flickity-Reinit).
   Elemente mit eigenem aria-hidden="true" (z.B. a.hero__slide-link, siehe
   sections/slideshow.liquid, dort bereits statisch tabindex="-1") werden
   bewusst uebersprungen: ihr Zustand ist slide-unabhaengig.
   Rollback: Datei entfernen und die eine Script-Zeile in
   layout/theme.liquid wieder loeschen (siehe
   40_PROJEKTE/VER_AGENTIC_ROLLBACK/layout_theme.liquid.orig). */
(function () {
  function syncSlide(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    var focusables = slide.querySelectorAll('a, button');
    for (var i = 0; i < focusables.length; i++) {
      var el = focusables[i];
      if (el.getAttribute('aria-hidden') === 'true') { continue; }
      if (hidden) {
        el.setAttribute('tabindex', '-1');
      } else if (el.getAttribute('tabindex') === '-1') {
        el.removeAttribute('tabindex');
      }
    }
  }

  function observeSlide(slide, observer) {
    if (slide.hasAttribute('data-ver-agentic-1-observed')) { return; }
    slide.setAttribute('data-ver-agentic-1-observed', 'true');
    syncSlide(slide);
    observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function init() {
    var slideObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
          syncSlide(m.target);
        }
      });
    });

    document.querySelectorAll('.slideshow__slide').forEach(function (slide) {
      observeSlide(slide, slideObserver);
    });

    var containerObserver = new MutationObserver(function () {
      document.querySelectorAll('.slideshow__slide').forEach(function (slide) {
        observeSlide(slide, slideObserver);
      });
    });
    containerObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* VER-BAR-1, 01.09.2026: Flickity misst Slider-Hoehen (u.a. die
   Ankuendigungsleiste .announcement-bar) teils bevor der Webfont Jost geladen
   ist und friert eine zu kleine Pixelhoehe als Inline-Style auf
   .flickity-viewport ein — der Balken erscheint dann halb, Text abgeschnitten.
   Nach fonts.ready einmal resize ausloesen, damit alle Flickity-Instanzen mit
   der echten Schrift neu messen. Rollback: diesen Block entfernen. */
(function () {
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }
})();
